import React from 'react'
import {connect} from 'react-redux'

import {SDKApp as PackagesSDKApp} from '@instructure/quiz-core/common/components/SDKApp/index'
import {rcsJwtRefreshFn} from '../actions/apiActions'

export const LtiSdkApp = ({
  rcsHost,
  rcsJwt,
  contextType,
  contextId,
  canvasHost,
  canvasToolId,
  userId,
  rcsJwtRefreshFn,
  timeZone,
  sdkTranslations,
  dispatch,
  ...otherProps
}) => {
  const composeRceConfig = () => {
    return {
      rcsHost,
      rcsJwt,
      contextType,
      contextId: contextId?.toString() || null,
      canvasOrigin: canvasHost,
      canvasUserId: userId,
      rcsJwtRefreshFn,
      canvasToolId,
    }
  }

  return (
    <PackagesSDKApp
      appContainer="#root"
      timeZone={timeZone}
      translations={sdkTranslations}
      rceConfig={composeRceConfig()}
      appDispatch={dispatch}
      {...otherProps}
    />
  )
}

export function mapStateToProps({context}) {
  return {
    timeZone: context.timeZone,
    sdkTranslations: context.sdkTranslations,
    rcsHost: context.rcsHost,
    rcsJwt: context.rcsJwt,
    contextId: context.canvasLocalContextId,
    userId: context.userCanvasId,
    contextType: context.contextType,
    canvasHost: context.canvasHost,
    canvasToolId: context.canvasToolId,
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch,
  rcsJwtRefreshFn: (...args) => dispatch(rcsJwtRefreshFn(...args)),
})

export const SDKApp = connect(mapStateToProps, mapDispatchToProps)(LtiSdkApp)
